<template>
<div id="page-carga_ds">
    <div>
        <v-breadcrumbs :items="breadcrumbs">
            <v-icon slot="divider">forward</v-icon>
        </v-breadcrumbs>
    </div>
    <v-dialog v-model="dialog" width="750px">
                    <v-card>
                        <v-card-text align-center>
                        <center>
                            <img src="https://s3.amazonaws.com/descargas.econnectpro.mx/inicial.png" alt="info" style="width:600px;" />

                        </center>
                        </v-card-text>
                        <v-card-actions style="padding:10px; margin-right:50px;">
                            <v-spacer></v-spacer>
                            <v-btn small color="default"  @click="dialog = false">
                                <v-icon  class="white--text" >close</v-icon>Cancelar
                            </v-btn>
                            <v-btn small color="purple" @click.native="download_layout('LayoutPedimentosInventario.xlsx');">
                                <v-icon  class="white--text" >receipt</v-icon>Descargar Layout..
                            </v-btn>
                            <UploadExcel  title="Importar Layout Pedimentos"  idInput="desKey" @click.native=" dialog = false" :on-success="handleSuccess" :before-upload="beforeUpload" :firstRow="2" />
                        </v-card-actions>

                    </v-card>
                </v-dialog>
                <v-dialog v-model="dialog2" width="750px">
                    <v-card>
                        <v-card-text align-center>
                        <center>
                            <img src="https://s3.amazonaws.com/descargas.econnectpro.mx/inicial.png" alt="info" style="width:600px;" />

                        </center>
                        </v-card-text>
                        <v-card-actions style="padding:10px; margin-right:50px;">
                            <v-spacer></v-spacer>
                            <v-btn small color="default"  @click="dialog2 = false">
                                <v-icon  class="white--text" >close</v-icon>Cancelar
                            </v-btn>
                            <v-btn small color="purple" @click.native="download_layout('LayoutPedimentosInventario.xlsx');">
                                <v-icon  class="white--text" >receipt</v-icon>Descargar Layout..
                            </v-btn>
                         </v-card-actions>

                    </v-card>
                </v-dialog>
    <v-container fluid fill-height>
        <v-layout align-center justify-center>
            <v-flex xs12>
                <base-material-card color="primary" icon="library_books" title="Indexar Pedimentos Inventario" class="elevation-1 px-5 py-3">
                
                    <v-card-text>
                          <v-card >
                        <v-card-actions>
                            <v-spacer></v-spacer>

                                <v-speed-dial id="descargos_sd" direction="left" open-on-hover>
                                    <template v-slot:activator>
                                        <v-btn id="descargos_sd_btn" x-small fab dark color="secondary" >
                                            <v-icon>reorder</v-icon>
                                        </v-btn>
                                    </template>
                                    <v-btn color="purple" fab x-small title="Información sobre Layout Pedimentos" @click.native=" dialog2 = true" v-tippy>
                                                    <v-icon>mdi-help-circle-outline</v-icon>
                                                </v-btn>
                                    <exportar-excel :data="datafiltered" :exportFields="des_excel" name="PedimentosIndexados.xlsx">
                                        <v-btn color="green" fab x-small title="Descargar Información" v-tippy>
                                        <v-icon  dark>mdi-table</v-icon>
                                        </v-btn>
                                    </exportar-excel>    
                                  
                                    <v-btn color="primary" fab x-small title="Importar Layout Pedimentos" @click.native=" dialog = true" v-tippy>
                                                    <v-icon>cloud_upload</v-icon>
                                                </v-btn>                           
                                </v-speed-dial>

                                </v-card-actions>
                                <v-card-text style="margin-top:0px;">

                                   
                                <v-client-table ref="vuetable" :data="bitacora.items" :columns="columns" :options="options" class="elevation-2 pa-2">
                                    <template slot="noResults">
                                        <v-alert :value="true" icon="info" color="info">No se encontro ningun registro</v-alert>
                                    </template>
                                
                                    <template slot="valor_comercial" slot-scope="props">
                                        <div class="text-number">
                                            {{formatNumber(props.row.valor_comercial, 2)}}
                                        </div>
                                    </template>
                                
                                    <template slot="actions" slot-scope="props" >
                                    
                                        <v-btn x-small fab dark color="red" @click.native="eliminar(props.row)" title="Eliminar" v-tippy>
                                            <v-icon>delete</v-icon>
                                        </v-btn>
                                    </template>
                            
                                </v-client-table>
                        </v-card-text>
                            </v-card>
                   
                    </v-card-text>
                </base-material-card>
           
            </v-flex>
        </v-layout>
    </v-container>
</div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import UploadExcel from '@/components/UploadExcel/UploadExcelInfo.vue';

export default {
    components: {
        "UploadExcel": UploadExcel,
     },
    data() {
        return {
            dialog: false,
            dialog2: false,
            encabezadoLayout: {
                "Numero de pedimento":"Numero de pedimento",
                "Clave de documento":"Clave de documento",	
                "Fecha de pago real":"Fecha de pago real",
                "Numero Partida":"Numero Partida",
                "Fraccion":"Fraccion",
                "Identificador":"Identificador",
                "Descripcion Mercancia":"Descripcion Mercancia",
                "Valor Comercial":"Valor Comercial",
                "Cantidad Unidad Medida Comercial":"Cantidad Unidad Medida Comercial",
                "Clave Unidad Medida Comercial":"Clave Unidad Medida Comercial",
                "Cantidad Unidad Medida Tarifa":"Cantidad Unidad Medida Tarifa",
                "Clave Unidad Medida Tarifa":"Clave Unidad Medida Tarifa",
                "Clave Pais Origen Destino":"Clave Pais Origen Destino",
                "Clave Pais Comprador Vendedor":"Clave Pais Comprador Vendedor",
                "Proveedor":"Proveedor",
                "Tipo de Documento":"Tipo de Documento",
            },
            //van vacíos para solo descargar layout con encabezados
            camposLayout: [{
                "Numero de pedimento":"",
                "Clave de documento":"",
                "Fecha de pago real":"",
                "Numero Partida":"",
                "Fraccion":"",
                "Identificador":"",
                "Descripcion Mercancia":"",
                "Valor Comercial":"",
                "Cantidad Unidad Medida Comercial":"",
                "Clave Unidad Medida Comercial":"",
                "Cantidad Unidad Medida Tarifa":"",
                "Clave Unidad Medida Tarifa":"",
                "Clave Pais Origen Destino":"",
                "Clave Pais Comprador Vendedor":"",
                "Proveedor":"",
                "Tipo de Documento":"",
            }],                
            camposObligatorios: [
                "Numero de pedimento",
                "Clave de documento",
                "Fecha de pago real",
                "Numero Partida",
                "Fraccion",
                "Identificador",
                "Descripcion Mercancia",
                "Valor Comercial",
                "Cantidad Unidad Medida Comercial",
                "Clave Unidad Medida Comercial",
                "Cantidad Unidad Medida Tarifa",
                "Clave Unidad Medida Tarifa",
                "Clave Pais Origen Destino",
                "Clave Pais Comprador Vendedor",
                "Proveedor",
                "Tipo de Documento",
            ],
           
            fab: false,
            periodos: [],
            registro: "",
         
            tipos_documento:[],
            destinos_aduaneros:[],
          
            name: "datagrid",
           
           
            columns: [
                "no_pedimento",  "fecha_pago",  "clave_pedimento", "secuencia_fraccion",  "fraccion_arancelaria", "identificador", "valor_comercial",
                "actions"
            ],
        
            
            show_loading: true,
            options: {
                filterable: [ "no_pedimento",  "fecha_pago",  "clave_pedimento", "secuencia_fraccion",  "fraccion_arancelaria", "identificador", "valor_comercial",
                ],
                sortable: ["no_pedimento",  "fecha_pago",  "clave_pedimento", "secuencia_fraccion",  "fraccion_arancelaria", "identificador", "valor_comercial"
                ],

                headings: {
                    "no_pedimento":"Número Pedimento",  
                    "fecha_pago":"Fecha Pago Real", 
                    "clave_pedimento":"Clave de Documento",
                    "secuencia_fraccion":"Número Partida", 
                    "fraccion_arancelaria":"Fracción", 
                    "Identificador":"Identificador",                      
                    "valor_comercial":"Valor Comercial",
                    actions: "Operaciones"
                }
            },
            des_excel:{
                "Numero de pedimento":"no_pedimento",
                "Clave de documento":"clave_pedimento",
                "Fecha de pago real":"fecha_pago",
                "Numero Partida":"secuencia_fraccion",
                "Fraccion":"fraccion_arancelaria",
                "Identificador":"identificador",  
                "Descripcion Mercancia":"descripcion_pedimento",
                "Valor Comercial":"valor_comercial",
                "Cantidad Unidad Medida Comercial":"cantidad_umc",
                "Clave Unidad Medida Comercial":"clave_umc",
                "Cantidad Unidad Medida Tarifa":"cantidad_umt",
                "Clave Unidad Medida Tarifa":"clave_umt",
                "Clave Pais Origen Destino":"pais_od",
                "Clave Pais Comprador Vendedor":"pais_cv",        
                "Proveedor":"proveedor",
                "Tipo de Documento":"material",               
                },
            show_loading: true,
            breadcrumbs: [{
                    text: "Inicio",
                    disabled: false,
                    to: "/home"
                },
                {
                    text: "Informes TXT",
                    disabled: true,
                    href: ""
                },
                {
                    text: "Indexar Pedimentos Inventario",
                    disabled: true,
                    href: ""
                }
            ],
            search: "",
            bitacora: {
                items: [],
                items_inicial: []
            },
        };
    },

    methods: {
        eliminar: function (row) {
            var self = this;
            self.$swal({
                type: "info",
                title: "Cuidado",
                text: "¿Está seguro de eliminar el registro?",
                footer: "",
                showCancelButton: true,
                cancelButtonColor: "#d33",
                confirmButtonColor: "#3085d6",
                confirmButtonText: "Aceptar",
                cancelButtonText: "Cancelar"
            }).then(result => {
                if (result.value) {
                    var rfc = this.$local_storage.get("rfc");
                    axios.post(this.$apiSA31 + "soluciona31/eliminar_pedimento_inventario/", {
                            'id': row._id,
                            'rfc': rfc,
                            'usuario': self.$local_storage.get("email"),
                        })
                        .then(response => {
                        
                            self.$swal({
                                    type: "success",
                                    title: "Operación Exitosa",
                                    text: "El registro se eliminó correctamente",
                                    footer: ""
                                });
                                
                                    self.getBitacora();
                                               

                        })
                        .catch(error => {
                            self.$swal({
                                type: "error",
                                title: "Operación No Permitida",
                                text: "El archivo no puede ser eliminado",
                                footer: ""
                            });
                        });
                        }
            });
            
        },
        beforeUpload(file) {
            const isLt2M = file.size / 1024 / 1024 < 2;

            if (isLt2M) {
                return true;
            }
            this.$swal({
                type: "warning",
                title: "¡Operación no Permitida!",
                text: "El archivo no debe ser mayor a 2MB.",
                footer: ""
            });
            return false;
        },
        base64ToArrayBuffer: function (base64) {
            var binaryString = window.atob(base64);
            var binaryLen = binaryString.length;
            var bytes = new Uint8Array(binaryLen);
            for (var i = 0; i < binaryLen; i++) {
                var ascii = binaryString.charCodeAt(i);
                bytes[i] = ascii;
            }
            return bytes;
        },
        download_layout: function (key) {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            var datos = {
                id: key,
                bucket: "descargas.econnectpro.mx"
            }
            let nombre_download = key.split("/").pop();
            axios.post(this.$hostname + "s3/download/", datos, {
                    "Content-type": "application/json",
                    "Access-Control-Allow-Origin": "*",
                    Allow: "POST",
                    "cache-control": "no-cache",
                })
                .then(response => {
                    var bytes = this.base64ToArrayBuffer(response.data);
                    let blob = new Blob([bytes], {
                            type: response.headers["content-type"]
                        }),
                        url = window.URL.createObjectURL(blob);

                    var a = document.createElement("a");
                    document.body.appendChild(a);
                    a.style = "display: none";
                    a.href = url;
                    a.download = nombre_download;
                    a.click();
                    a.parentNode.removeChild(a);
                })
                .catch(error => {
                    console.log(error);

                }).then(() => {
                    this.$root.$dialogLoader.hide();
                });

        },
        parseDateExcel(excelDate) {
            try {
                if (!excelDate) return false;
                var fecha = '';
                if (excelDate.toString().indexOf('/') != -1 || excelDate.toString().indexOf('-') != -1){                    
                    fecha = moment(String(excelDate)).format("YYYY-MM-DD");
                }else{                    
                    fecha = moment((Math.floor(excelDate) - (25567 + 1)) * 86400 * 1000).format("YYYY-MM-DD");
                }
                if (fecha == 'Invalid date') return false;
                return fecha;
            } catch (error) {
                return false;
            }
        },
        verificaObligatorios: function (results) {
            var errores = '';
            var keys = [];
            for (var k in results) {
                keys.push(k);
            }
            this.camposObligatorios.forEach(function (campo) {
                if (keys.indexOf(campo) == -1)
                    errores += '<br/>' + "- El campo '" + campo + "' es obligatorio.";
            });

            return errores == '' ? true : errores;
        },
        validarPatronPedimento(pedimento){
            const patternPedimento = /^[0-9]{3}-{1}[0-9]{4}-{1}[0-9]{7}$/;
            return patternPedimento.test(pedimento);
        },
        validaEntero(numero){
            const pattern = /^[\d]*$/;
            return pattern.test(numero);
        },
        validaFloat: function(numero) {
            const pattern = /^\d*(\.\d*)?$/;
            return pattern.test(numero);
        },
        validaCargaLayout: async function (results) {
            var thisObject = this;
            //return new Promise(function(resolve, reject){
            var errores = 0;
            var erroresText = '';
            var errorTmp = '';
            try {
                if (results.length == 0) {
                    errores++;
                    erroresText += "No hay datos en el layout. Verifique que exista información a partir del 2do renglón.";
                } else {
                    for (var k in results) {                                                

                        var obligatorios = this.verificaObligatorios(results[k]);
                        if (obligatorios !== true) {
                            errores++;
                            if (erroresText.indexOf(obligatorios) == -1)
                                erroresText += obligatorios;
                        } else {
                            
                            //Si trae el campo no_partidas, marcamos error ya que este es para pedimento
                            if(!this.validarPatronPedimento(results[k]['Numero de pedimento'])){
                                errores++;
                                errorTmp = '<br/>' + "- El número '" + results[k]['Numero de pedimento'] + "' no es un pedimento válido. Ej. 240-1234-9000123";
                                if (erroresText.indexOf(errorTmp) == -1)
                                    erroresText += errorTmp;
                            }

                            let fechaOrig = results[k]["Fecha de pago real"];
                            results[k]["Fecha de pago real"] = thisObject.parseDateExcel(fechaOrig);
                            if (results[k]["Fecha de pago real"] == false) {
                                errores++;
                                errorTmp = '<br/>' + "- La fecha '" + fechaOrig + "' no es una fecha válida.";
                                if (erroresText.indexOf(errorTmp) == -1)
                                    erroresText += errorTmp;
                            }

                            if(!this.validaEntero(results[k]['Numero Partida'])){                                
                                errores++;
                                errorTmp = '<br/>' + "- El Numero Partida '" + results[k]['Numero Partida'] + "' debe ser número entero";
                                if (erroresText.indexOf(errorTmp) == -1)
                                    erroresText += errorTmp;
                            } else {
                                results[k]['Numero Partida'] = parseInt(results[k]['Numero Partida']);
                            }

                            if(!this.validaFloat(results[k]['Valor Comercial'])){                                
                                errores++;
                                errorTmp = '<br/>' + "- El Valor Comercial '" + results[k]['Valor Comercial'] + "' no es una cantidad válida";
                                if (erroresText.indexOf(errorTmp) == -1)
                                    erroresText += errorTmp;
                            } else {
                                results[k]['Valor Comercial'] = parseFloat(results[k]['Valor Comercial']);
                            }

                            if(!this.validaFloat(results[k]['Cantidad Unidad Medida Comercial'])){                                
                                errores++;
                                errorTmp = '<br/>' + "- La Cantidad Unidad Medida Comercial '" + results[k]['Cantidad Unidad Medida Comercial'] + "' no es una cantidad válida";
                                if (erroresText.indexOf(errorTmp) == -1)
                                    erroresText += errorTmp;
                            } else {
                                results[k]['Cantidad Unidad Medida Comercial'] = parseFloat(results[k]['Cantidad Unidad Medida Comercial']);
                            }

                            if(!this.validaFloat(results[k]['Cantidad Unidad Medida Tarifa'])){                                
                                errores++;
                                errorTmp = '<br/>' + "- La Cantidad Unidad Medida Tarifa '" + results[k]['Cantidad Unidad Medida Tarifa'] + "' no es una cantidad válida";
                                if (erroresText.indexOf(errorTmp) == -1)
                                    erroresText += errorTmp;
                            } else {
                                results[k]['Cantidad Unidad Medida Tarifa'] = parseFloat(results[k]['Cantidad Unidad Medida Tarifa']);
                            }
                                                       

                        }
                        //console.log("Key is " + k + ", value is" + results[k]);
                    }

                }

                return ({
                    "errores": errores,
                    "erroresText": erroresText
                });

            } catch (error) {
                console.log(error);
                thisObject.$swal({
                    type: "warning",
                    title: "¡Operación no Permitida!",
                    text: "Error al cargar el archivo. Verifique que no existan celdas vacías.",
                    footer: error.message,
                });
            }
            //}); //promise

        },
        handleSuccess: async function ({
            results,
            header
        }) {
            let self = this;
            var errores = 0;
            var erroresText = '';
            let importData = [];
            var rfc = this.$local_storage.get("rfc");
            try {
                this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
                let validaciones = await this.validaCargaLayout(results);
                if (validaciones.errores > 0) {
                    this.$swal({
                        type: "warning",
                        title: "¡Operación no Permitida!",
                        text: "Existen errores al cargar el archivo. Corrija y vuelva a intentarlo.",
                        footer: validaciones.erroresText,
                    });
                    this.$root.$dialogLoader.hide();
                } else {
                    this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
                    results.forEach(function(x){
                        importData.push({    
                                "rfc": rfc,                
                                "no_pedimento":x["Numero de pedimento"],
                                "clave_pedimento":x["Clave de documento"],
                                "fecha_pago":x['Fecha de pago real'],
                                "secuencia_fraccion":x["Numero Partida"],                            
                                "fraccion_arancelaria":x["Fraccion"],
                                "identificador":x["Identificador"],
                                "descripcion_pedimento":x["Descripcion Mercancia"],
                                "valor_comercial":x["Valor Comercial"],
                                "cantidad_umc":x["Cantidad Unidad Medida Comercial"],
                                "clave_umc":x["Clave Unidad Medida Comercial"],
                                "cantidad_umt":x["Cantidad Unidad Medida Tarifa"],
                                "clave_umt":x["Clave Unidad Medida Tarifa"],
                                "pais_od":x["Clave Pais Origen Destino"],
                                "pais_cv":x["Clave Pais Comprador Vendedor"],
                                "proveedor":x["Proveedor"],
                                "material":x["Tipo de Documento"], 
                                //CAMPOS EXTRAS ANTERIORES
                                //"fecha_entrada":self.parseDateExcel(x['fecha_entrada']),
                                //"tipo_cambio":x["tipo_cambio"],
                                //"regimen":x["regimen"],                            
                                //"aduana":x["aduana"],
                                //"patente":x["patente"],
                                //"pedimento":x["pedimento"],
                                //"proveedor":x["proveedor"],
                                //"factura":x["factura"],
                                //"fecha":x['fecha'],
                                //"material":x["material"],                            
                                //"valor_aduana":x["valor_aduana"],
                                //"metodo_valoracion":x["metodo_valoracion"],                            
                                //"identificador":x["identificador"],                            
                                //"tlc":x["tlc"],
                                //"prosec":x["prosec"],
                                //"numero_permiso":x["numero_permiso"],
                                //"identificador_empaque":x["identificador_empaque"]
                            });

                    });
                    
                        let data = {
                            'rfc': rfc,
                            'rows': importData
                        }

                        axios
                            .post(this.$apiSA31  + "/soluciona31/layout_pedimentos_inventario/", data)                            
                            .then(response => {
                            
                        })
                            .catch(err => {
                                var errores = "";
                                this.$swal({
                                    type: "error",
                                    title: "¡Operación no Permitida!",
                                    text: "Error al cargar el archivo. Verifique el contenido del archivo",
                                    footer: errores
                                });
                            })
                            .then(() => {
                                this.$root.$dialogLoader.hide();
                                this.getBitacora();                                
                            });
                }                              

            } catch (error) {
                this.$swal({
                    type: "warning",
                    title: "¡Operación no Permitida!",
                    text: "Error al cargar el archivo. Verifique el contenido del archivo",
                    footer: error.message,
                });
                this.$root.$dialogLoader.hide();
            }
        },
   
        getBitacora: function () {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            var rfc = this.$local_storage.get("rfc");
            let self = this;
            axios.post(this.$apiSA31 + "soluciona31/list_pedimentos_inventario/", {
                    'rfc': rfc,
              //      'campos':{'fecha':1,'tipo':1, 'usuario':1, 'documento.fecha':1, 'documento.folio':1, 'documento.cabecera':1, 
                //    'documento.valor_comercial_final':1, 
                 //   'key':1 , 'documento.planta':1
                //     },
                  //   filtros: {"estatus": {"$in": ['Creado',  'Aplicado']}}, 
                })
                .then(response => {
                    self.bitacora.items = response.data;

                    for (var k in this.bitacora.items) {
                        self.bitacora.items[k].fecha_pago = moment(String(self.bitacora.items[k].fecha_pago)).format("YYYY-MM-DD");                        
                    }
                    self.bitacora.items.sort(function (a, b) {
                        //Ordenar por fecha más reciente
                        new Date(b.fecha_pago) - new Date(a.fecha_pago);                        
                    });

                    self.$root.$dialogLoader.hide();
                })
                .catch(error => {

                    self.$root.$dialogLoader.hide();
                });
        },
    
        getPeriodos: function () {
    
            axios.post(this.$hostname + "apendices/lista/", {
                    'tabla': 32
                })
                .then(response => {
                 
                    this.periodos = response.data;
                    this.getTiposDocumento();
                    this.getDestinosAduaneros();
                    this.getBitacora();

                })
                .catch(error => {

                });
        },
        getTiposDocumento: function () {

                axios.post(this.$hostname + "apendices/lista/", {
                        'tabla': 31
                    })
                    .then(response => {
                        this.tipos_documento = response.data;
                    })
                    .catch(error => {

                    });
                },
        getDestinosAduaneros: function () {

                axios.post(this.$hostname + "apendices/lista/", {
                        'tabla': 30
                    })
                    .then(response => {
                        this.destinos_aduaneros = response.data;
                    })
                    .catch(error => {

                    });
        },        
      
    
     
        formatNumber: function (numero, decimales) {
            if (numero == undefined || numero == null || numero == "")
                numero = 0;
            numero = Number(numero);
            if (isNaN(numero)) {
                return "";
            } else
                return (numero).toFixed(decimales).replace(/\d(?=(\d{3})+\.)/g, '$&,');
        },
        downloadFile: function (nombre) {
            let rfc = this.$local_storage.get("rfc");
            rfc = rfc.toString().trim().toUpperCase();
          
            //alert(nombre);
            var datos = {
                id: nombre,
                bucket: "production.econnect.ds"
            };
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            axios.post(this.$hostname + 's3/download_url/', datos)
                .then((res) => {
                    if (typeof res.data !== 'undefined') {
                        var a = document.createElement("a");
                        document.body.appendChild(a);
                        a.style = "display: none";
                        a.href = res.data.mensaje;
                        a.target = "_blank";
                        a.click();
                        a.parentNode.removeChild(a);

                    } else {
                        this.$swal({
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "No se encontró el archivo a descargar. Intente nuevamente por favor.",
                            footer: '',
                        });
                    }
                })
                .catch((error) => {
                    var mensaje = "Ocurrió un error al descargar el archivo";
                    if (error.response != undefined && error.response.data != undefined && error.response.data.mensaje != undefined)
                        mensaje = error.response.data.mensaje;
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: mensaje,
                        footer: '',
                    });
                    console.log(error);
                }).then(() => {
                    this.$root.$dialogLoader.hide();
                });

        },
        },
      computed: {
        
        planta_referencia() {
            return  this.$local_storage.get("Modulo16") == 100 ;
        },
        datafiltered() {
            let self = this;
            let result = [];
            if (this.$refs.vuetable != null) {
                result = this.$refs.vuetable.allFilteredData;
                return result;
            } else {
                result = this.bitacora.items;
                return result;
            }
        },
     
      
    },   
    mounted: function () {
       
        this.getBitacora();

    },
};
</script>

<style scoped>
.table-bordered thead th,
.table-bordered thead td {
    font-size: x-small !important;
}

.text-number {
    text-align: right;
}
.VueTables>>>thead th {
  white-space: normal !important;
  text-align: center !important;
}
</style>
